import { render, staticRenderFns } from "./ModalProduct.vue?vue&type=template&id=3facd9dd&scoped=true&"
import script from "./ModalProduct.vue?vue&type=script&lang=js&"
export * from "./ModalProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalProduct.vue?vue&type=style&index=0&id=3facd9dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3facd9dd",
  null
  
)

export default component.exports